<template>
  <section>
    <el-form class="form_cls" v-if="buttonList != null && buttonList.length > 0" :model="filters" @submit.native.prevent inline>
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item label="手术开始日期">
        <el-date-picker
          :prefix-icon="isMobile ? '11' : ''"
          style="width: 140px !important"
          v-model="filters.start_date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="开始时间"
          :picker-options="startDateOptions"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="手术结束日期">
        <el-date-picker
          :prefix-icon="isMobile ? ' ' : ''"
          style="width: 140px !important"
          v-model="filters.end_date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="结束时间"
          :picker-options="endDateOptions"
        ></el-date-picker>
      </el-form-item>
      <el-form-item
        v-if="!item.IsHide && (isMobile && item.name == '导出' ? false : true)"
        class="input_width_100"
        v-for="item in buttonList"
        v-bind:key="item.id"
      >
        <!-- 这里触发点击事件 -->
        <el-button
          style="margin-bottom: 8px"
          :type="
            item.Func && (item.Func.toLowerCase().indexOf('handledel') != -1 || item.Func.toLowerCase().indexOf('stop') != -1) ? 'danger' : 'primary'
          "
          @click="callFunc(item)"
        >
          {{ item.name }}
        </el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div class="table_top_div" style="margin-bottom: 5px">
      <el-table
        :data="tabel_list"
        :border="true"
        :cell-style="cellStyle"
        cell-class-name="cell_class_name"
        max-height="100%"
        header-cell-class-name="header_cell_name"
        highlight-current-row
        v-loading="listLoading"
        style="width: 100%"
      >
        <el-table-column prop="name" label="销售代表" width="100"></el-table-column>
        <el-table-column :label="todaylabel">
          <el-table-column prop="target" label="指标" width="">
            <template slot-scope="scope">
              <span :style="scope.row.isBold ? 'font-weight: bold;font-size:12px' : 'font-size:12px'">
                {{ currency(scope.row.target) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="number" label="数量" width="">
            <template slot-scope="scope">
              <span :style="scope.row.isBold ? 'font-weight: bold;font-size:12px' : 'font-size:12px'">
                {{ currency(scope.row.number) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="achieve" label="达成" width="">
            <template slot-scope="scope">
              <span :style="scope.row.isBold ? 'font-weight: bold;font-size:12px' : 'font-size:12px'">
                {{ (scope.row.achieve * 100).toFixed(0) }}%
              </span>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <!-- <el-button type="primary" v-preventReClick="3000" @click="save" style="color: white; width: 100%; font-size: 16; margin-top: 20px">
        确认上报
      </el-button> -->
    </div>
  </section>
</template>

<script>
import { flacs_saveDailyData, flacs_getmtddata } from '../../api/api'
import { getButtonList } from '../../promissionRouter'

export default {
  data() {
    return {
      todaylabel: '',
      isMobile: false,
      tableHeight: 0,
      buttonList: [],
      token: '',
      filters: {
        pageSize: 200,
        start_date: '',
        end_date: '',
      },
      tabel_list: [],
      pageNumber: 1,
      listLoading: false,
    }
  },
  computed: {
    // 开始日期选择限制：不能晚于结束日期，不能选择明天及以后
    startDateOptions() {
      const self = this
      return {
        disabledDate(time) {
          // 禁用今天及以后的日期
          const today = new Date()
          today.setHours(0, 0, 0, 0)
          if (time.getTime() > today.getTime()) {
            return true
          }
          
          // 禁用晚于结束日期的日期
          if (self.filters.end_date) {
            return time.getTime() > new Date(self.filters.end_date).getTime()
          }
          return false
        }
      }
    },
    // 结束日期选择限制：不能早于开始日期，不能选择明天及以后
    endDateOptions() {
      const self = this
      return {
        disabledDate(time) {
          // 禁用今天及以后的日期
          const today = new Date()
          today.setHours(0, 0, 0, 0)
          if (time.getTime() > today.getTime()) {
            return true
          }
          
          // 禁用早于开始日期的日期
          if (self.filters.start_date) {
            const startDate = new Date(self.filters.start_date)
            startDate.setHours(0, 0, 0, 0)
            const compareDate = new Date(time)
            compareDate.setHours(0, 0, 0, 0)
            return compareDate.getTime() < startDate.getTime()
          }
          return false
        }
      }
    }
  },
  methods: {
    currency(val) {
      if (val == '' || val == null) {
        return val
      }
      if (Number(val) == 0) {
        return 0
      }
      let precision = 0
      let decimal = this.checkNaN(val, (v) => v.toFixed(precision))
      const [n, d = []] = decimal.toString().split('.')
      return [n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')].concat(d).join('.')
      //   }
    },
    checkNaN(value, cb) {
      const val = parseFloat(value)
      return isNaN(val) ? undefined : cb(val)
    },
    back_url() {
      //   this.$router.replace({ path: this.$route.query.back_url })
      this.$router.go(-1)
    },
    async save(res) {
      const { data } = await flacs_saveDailyData(this.tabel_list)
      if (data.code == 200) {
        this.$message.success(data.msg)
        this.back_url()
      } else {
        this.$message.error(data.msg)
      }
    },
    callFunc(item) {
      this[item.Func].apply(this, item)
    },
    handleCurrentChange(val) {
      this.pageNumber = val
      this.getModules()
    },
    getModules_search() {
      this.pageNumber = 1
      this.getModules()
      //   this.getModules2()
    },
    //获取用户列表
    getModules() {
      let para = JSON.parse(JSON.stringify(this.filters))
      para.pageNumber = this.pageNumber
      if (para.start_date == para.end_date) {
        this.todaylabel = para.start_date
      } else {
        this.todaylabel = para.start_date + ' 至 ' + para.end_date
      }

      this.listLoading = true
      flacs_getmtddata(para).then((res) => {
        this.tabel_list = res.data
        this.listLoading = false
      })
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - 250
    })
    if (window.innerWidth <= 767) {
      this.isMobile = true
      this.collapsedClass = 'menu-collapsed'
      //   this.SidebarVisible = false
    }
    var time = new Date()
    var year = time.getFullYear()
    var month = time.getMonth() + 1
    var day = time.getDate()
    var today = year + '-' + (Number(month) < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day)
    var monthStart = year + '-' + (Number(month) < 10 ? '0' + month : month) + '-01'
    // 默认查询本月数据（从本月1日到今天）
    this.filters.start_date = monthStart
    this.filters.end_date = today
    this.todaylabel = monthStart + ' 至 ' + today
    this.getModules_search()
    let tokenStr = window.localStorage.Token
    this.token = {
      Authorization: 'Bearer ' + tokenStr,
    }
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : []
    this.buttonList = getButtonList(this.$route.path, routers)
    console.log(this.buttonList)
  },
}
</script>

<style>
.expends_cls .cell {
  padding: 0 5px !important;
}
.el-collapse-item__header {
  font-size: 14px !important;
  font-weight: bold !important;
  /* background-color: rgba(0, 0, 0, 0) !important;
  border-bottom: 1px solid rgb(203, 203, 203) !important; */
  padding-left: 5px !important;
}
.cell_class_name {
  text-align: center !important;
}
/* .el-input__inner {
  padding: 5px !important;
} */
.el-collapse-item__wrap {
  background-color: none !important;
  background-color: rgba(0, 0, 0, 0) !important;
}
.expends_cls td.el-table__cell {
  padding: 1px 0 !important;
}
</style>
